import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GenreFeedService } from "../services/GenreFeedService";
import "../styles/GenrePills.css";

interface GenrePillsProps {
  onGenreClick?: (genre: string) => void;
}

const PILL_GRADIENTS = [
  "linear-gradient(135deg, #C33764 0%, #1D2671 100%)", // Deep Pink to Navy
  "linear-gradient(135deg, #F27121 0%, #E94057 100%)", // Vivid Orange to Red
  "linear-gradient(135deg, #4A00E0 0%, #8E2DE2 100%)", // Electric Violet
  "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)", // Dark Teal to Neon Green
  "linear-gradient(135deg, #0F2027 0%, #2C5364 100%)", // Deep Ocean Blue
  "linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)", // Hot Pink to Orange
  "linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)", // Cyber Blue
  "linear-gradient(135deg, #833ab4 0%, #fd1d1d 100%)", // Deep Purple to Red
];

export const GenrePills = ({ onGenreClick }: GenrePillsProps) => {
  const [genres, setGenres] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadGenres = async () => {
      const fetchedGenres = await GenreFeedService.fetchUniqueGenres();
      setGenres(fetchedGenres);
      setLoading(false);
    };

    loadGenres();
  }, []);

  const getPillGradient = (index: number) => {
    return PILL_GRADIENTS[index % PILL_GRADIENTS.length];
  };

  const handleClick = (genre: string) => {
    if (onGenreClick) {
      onGenreClick(genre);
    } else {
      navigate(`/genres/${encodeURIComponent(genre)}`);
    }
  };

  if (loading) {
    return null;
  }

  if (genres.length === 0) {
    return null;
  }

  return (
    <div className="genre-pills-root">
      <h3 className="genre-pills-header">Browse by Genre</h3>

      <div className="genre-pills-scroll-view">
        {genres.map((genre, index) => (
          <div
            key={genre}
            className="genre-pills-card"
            onClick={() => handleClick(genre)}
            style={{
              background: getPillGradient(index),
              textShadow: "0 1px 2px rgba(0,0,0,0.3)",
            }}
          >
            {genre}
          </div>
        ))}
      </div>
    </div>
  );
};